import createMockSource from 'utils/createMockSource';

export const healthTabMocks = createMockSource('droneHealthTab', {
    batteryCycles: '144 / 300',
    levelCalibration: '17 days ago',
    magnetometerCalibration: '4 days ago',
    pumpCalibration: '12 days ago',
    weightCalibration: '21 days ago'
});
